module.exports = __webpack_public_path__ + "static/media/127 Final.c0b11ac4.pdf";